import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Slider from 'react-slick';
import { withRouter } from "react-router-dom";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getSliderPublisher } from '../../api/index';

class SliderFrontPublisher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      main_slider: []
    }
  }
  loadSliderPublisher = () => {
    console.log("loadSliderPublisher triggered");
    // const content = { name: "main" };
    const {penerbitId} = this.props;
    const content = {
      name: "Slider Publisher",
      companyId: 21, 
      penerbitId: penerbitId 
    };
    getSliderPublisher(content)
      .then(result => {
        console.log("Result from getSliderPublisher:", result);
        const main_slider_preview = result.result.map((value) => ({
          id: value.id,
          slidebar: value.slidebar,
          hyperlink: value.hyperlink,
          order: value.order,
          name: value.name
        }));
        this.setState({ main_slider: main_slider_preview });
      })
      .catch(error => {
        console.error("Error loading main slider:", error);
        this.setState({ main_slider: [] });
      });
  };
  

  componentDidMount() {
    this.loadSliderPublisher();
  }

  onClickSliderWrapperHandler = (e, hyperlink) => {
    e.preventDefault();
    if (hyperlink) {
      const link = hyperlink.split(".com");
      if (link[0] === "https://ipbpress" || link[0] === "https://www.ipbpress") {
        this.props.history.push(link[1]);
      } else {
        window.open(hyperlink, "_blank");
      }
    }
  }

  render() {
    //percobaan
    // const { sliders } = this.props; 
    // if (!sliders || sliders.length === 0) return null; 
    const setting = {
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 480,
        vertical: true,
        verticalSwiping: true,
      }]
    };

    let slide = (
      <div className="item-slider-wrapper">
        <div
          className="loading-background"
          style={{ width: "100%", height: "298px" }}
        />
      </div>
    );

    if (this.state.main_slider.length > 0) {
      slide = this.state.main_slider.map((value, index) => (
        <div
          className="item-slider-wrapper"
          onClick={(e) => this.onClickSliderWrapperHandler(e, value.hyperlink)}
          key={index}
        >
          <div
            className="loading-slider"
            style={{
              width: "100%",
              height: "298px", 
              backgroundImage: `url(${value.slidebar})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat"
            }}
          />
        </div>
      ));
    }

    return (
      <Container>
        <div className="slider-wrapper">
          <div className="inner-container-sliderimprint">
            <div className="main-slider">
              <Slider {...setting}>
                {slide}
              </Slider>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}
export default withRouter(SliderFrontPublisher);

